export default __webpack_public_path__ + "static/media/001-guarantee.a8d3ec15.png";